import React from "react";
import "../../css/pages/comment.scss";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useCreateComment } from "../../queries/comments";

interface Props {
  category: string;
  contentId: number;
}
const Comment: React.FC<Props> = (Props) => {
  const { mutate, isPending, reset, isSuccess, isError, error } =
    useCreateComment();
  const initialValues = {
    name: "",
    email: "",
    commentBody: "",
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, "اسم باید بیشتر از 2 حرف باشد")
      .max(20, "اسم باید کمتر از 20 حرف باشد")
      .required("وارد کردن این سطر الزامی است"),

    commentBody: Yup.string()
      .min(4, "")
      .max(200, "متن پیام باید کمتر از 200 حرف باشد")
      .required("وارد کردن این سطر الزامی است"),

    email: Yup.string()
      .email("فرمت ایمیل وارد شده درست نیست")
      .required("وارد کردن این سطر الزامی است"),
  });

  interface ISubmitedData {
    name: string;

    commentBody: string;
    email: string;
    PostId?: number;
    GalleryId?: number;
  }
  const onSubmit = (
    data: ISubmitedData,
    { resetForm }: { resetForm: () => void }
  ) => {
    Props.category === "posts"
      ? (data.PostId = Props.contentId)
      : (data.GalleryId = Props.contentId);

    mutate(
      { category: Props.category, data },
      {
        onSuccess: () => {
          resetForm();
        },
      }
    );
  };
  return (
    <div className="commentContainer">
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        <Form>
          <h3>دیدگاهتان را بنویسید</h3>
          <label htmlFor="fname">اسم</label>
          <Field type="text" id="name" name="name" placeholder="...اسم شما" />
          <ErrorMessage name="name" component="span" />
          <label htmlFor="lname">ایمیل</label>
          <Field
            type="email"
            name="email"
            id="email"
            placeholder="...ایمیل شما"
          />
          <ErrorMessage name="email" component="span" />

          <label htmlFor="commentBody">نظر </label>
          <Field
            as="textarea"
            id="commentBody"
            name="commentBody"
            placeholder="...نظر شما"
            style={{ height: "200px", marginBottom: "0" }}
          ></Field>
          <ErrorMessage name="commentBody" component="span" />

          <input type="submit" value="ارسال نظر" disabled={isPending} />
          <div
            className="successSubmitMessage"
            style={{ display: isSuccess ? "block" : "none", marginTop: 8 }}
          >
            پیام شما با موفقیت ارسال شد
          </div>
          <div
            className="successSubmitMessage"
            style={{
              display: isError ? "block" : "none",
              color: "red",
              marginTop: 8,
            }}
          >
            خطا در ارسال پیام، لطفا دوباره تلاش کنید
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default Comment;
